import {isFeatureEnabled} from 'feature-flags';

import {Module, Permission} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import featureFlags from '@dms/feature-flags';
import {interestRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {buildArray} from 'shared/web';

import {InterestCreate} from './pages/InterestCreate/InterestCreate';
import {InterestDetail} from './pages/InterestDetail/InterestDetail';
import {InterestOverview} from './pages/InterestOverview/InterestOverview';

export function useInterestModule(): Module {
  const isWorkshopInterestEnabled = isFeatureEnabled(featureFlags.WORKSHOP_INTEREST);

  return {
    id: moduleKeys.interest,
    layoutProps: {
      title: 'page.interests.title',
      icon: 'sidebar/interest',
    },
    routerProps: {
      path: interestRoutes.overview,
      element: <InterestOverview />,
    },
    requiredPermissionAtLeastOne: buildArray<Permission>([permissions.businessCaseRead])
      .when(isWorkshopInterestEnabled, permissions.serviceCaseRead)
      .when(isWorkshopInterestEnabled, permissions.workshopInterestRead),
    content: [
      {
        id: 'interest-overview',
        routerProps: {
          path: interestRoutes.overview,
          element: <InterestOverview />,
        },
      },
      {
        id: 'interest-workshop-overview',
        routerProps: {
          path: interestRoutes.workshopOverview,
          element: <InterestOverview />,
        },
      },
      {
        id: 'interest-detail',
        routerProps: {
          paths: [
            interestRoutes.detailOverview,
            interestRoutes.detailCustomer,
            interestRoutes.detailSelling,
            interestRoutes.detailBuying,
            interestRoutes.detailChecklists,
            interestRoutes.detailTasks,
            interestRoutes.detailActivityLog,
          ],
          element: <InterestDetail />,
        },
      },
      {
        id: 'interest-create',
        routerProps: {
          path: interestRoutes.create,
          element: <InterestCreate />,
        },
        requiredPermission: permissions.interestCreate,
        layoutProps: {
          title: 'entity.interest.actions.newInterest',
          isPartOfCreateMenuItem: true,
        },
      },
    ],
  };
}
